import { z } from 'zod';

export const GranolaStatusSchema = z.object({
	status: z.enum(['connected', 'not_connected']),
});
export type GranolaStatus = z.infer<typeof GranolaStatusSchema>;

// MCP OAuth — kept for reference
// export const GranolaAuthorizeSchema = z.object({
// 	redirectUrl: z.string(),
// });
// export type GranolaAuthorize = z.infer<typeof GranolaAuthorizeSchema>;

export const GranolaConnectSchema = z.object({
	connected: z.boolean(),
});
export type GranolaConnect = z.infer<typeof GranolaConnectSchema>;

export const GranolaDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type GranolaDisconnect = z.infer<typeof GranolaDisconnectSchema>;
